module.exports = __webpack_public_path__ + "img/sound-off-icon.933b563c.svg";